export default __webpack_public_path__ + "static/media/789d48f2.svg";